import $ from 'jquery';
export default class ContentList {
	constructor(containerSelector, data) {
		this.container = document.querySelector(containerSelector);
		this.data = data;
	}

	bindData() {
		if (this.container) {
			this.container.innerHTML = '';
			this.data.forEach((item, i) => {
				var contentListItem = document.createElement('div');
				contentListItem.className = 'col-12 shadow-sm p-3 mb-2 bg-light text-dark clickable';
				contentListItem.setAttribute('data-id', item.id);

				var header = document.createElement('h4');
				header.innerText = item.title;

				const truncate = (input, maxlength) => {
					if (input.length > maxlength) {
						return input.substring(0, maxlength) + '...';
					}
					return input;
				};

				var weiterlesen = document.createElement('a');
				weiterlesen.className = 'btn btn-sm btn-primary float-right no-underline';

				contentListItem.appendChild(header);
				if (item.excerpt) {
					var text = document.createElement('p');
					text.innerText = $(item.excerpt).text();
					weiterlesen.innerText = 'weiterlesen';

					contentListItem.appendChild(text);
					contentListItem.appendChild(weiterlesen);
				} else {
					weiterlesen.innerText = 'lesen';
					header.appendChild(weiterlesen);
					header.className = 'm-0';
				}

				this.container.appendChild(contentListItem);
			});
			$('.clickable').on('click', (e) => {
				const id = $(e.currentTarget).data('id');
				console.log(id);
				window.location.href = '/hintergrund.html#' + id;
			});
		}
	}
}
